
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    activeEncubadora: null,
    encubadora: [],
    isLoadingEncubadora: false,
    totalEncubadora: 0,
    
});






export const useEncubadoraStore = create()(
    devtools(
        storeApi
    )
)
